// RealmSelectPage — multi-tenant company picker.
//
// In v1 the staff member belongs to exactly one company (the JWT carries the
// cid). The legacy multi-tenant super-user picker is deferred. For now this
// page just bounces the user back to /login if they land here directly,
// or to / if they're already authenticated.
//
// Reachable URL: /realm-select. Not navigable from anywhere in v1 — exposed
// for completeness and for the future multi-company flow.

import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

export function RealmSelectPage() {
  const status = useAuthStore((s) => s.status);

  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }
  return <Navigate to="/login" replace />;
}
